import { regexp } from "./regexp";

export function parseSymbols(rows = [], hideLangBtn = false) {
  return rows.map(row => {
    if (hideLangBtn) {
      row = row.replace(regexp.findLangBtn, "");
    }

    let symbols = row.match(regexp.findSymbols);
    return symbols;
  });
}
